import { useEffect, useRef } from 'react';
import { Tooltip } from '@cb/apricot-react';

interface TooltipWrapperProps {
  children: React.ReactNode;
  className?: string;
  placement?: string;
  show?: boolean;
  light?: boolean;
  tooltipId?: string;
  trigger: string;
}

/*
  wrapper for Apricot 4 tooltip that adds an option to show the tooltip upon creation
  (when show = true)
 */
export default function TooltipWrapper({
  children = {},
  className = '',
  placement = 'top',
  show = false,
  light = false,
  tooltipId = '',
  trigger = '',
}: TooltipWrapperProps) {
  const cbRef = useRef();

  useEffect(() => {
    if (show) {
      cbRef.current.show();
    }
  }, [show]);

  return (
    <div style={{ position: 'absolute', left: '-9999px' }}>
      <Tooltip
        cbRef={cbRef}
        light={light}
        placement={placement}
        trigger={trigger}
        tooltipId={tooltipId}
        className={className}
      >
        {children}
      </Tooltip>
    </div>
  );
}
